<header class="site-header sticky-top" #h_Top>
  <div class="container">
    <div class="row">
      <div class="menu-button hidden-lg">
        <a role="button" tabindex="0" style="cursor: pointer;" (click)="helpSidebar = true; $event.preventDefault()">
          <i class="fa fa-bars" aria-hidden="true"></i>
        </a>
      </div>
      <section *ngIf="!powerMaster">
        <div class="logo">
          <a [routerLink]="'/' + shareModel.urlPath.Dashboard">
            <span class="logo-icon"><img src="../assets/images/logo_icon.png"></span>
            <span class="logo-text"><img src="../assets/images/logo_text.png"></span>
          </a>
        </div>
      </section>
      <section *ngIf="powerMaster">
        <div class="logo">
          <div class="flex">
            <span class="logo-icon"><img src="{{logoPath}}"></span>
          </div>
        </div>
      </section>
      <div class="help">
        {{'HELP' | translate}}
      </div>
    </div>
  </div>
</header>
<a class="scroll_top" (click)="scrollToElement(h_Top)" [ngClass]="{'show-scrollTop': windowScrolled}">
  <i class="fa fa-chevron-circle-up" aria-hidden="true"></i>
</a>
<p-drawer [(visible)]="helpSidebar" [baseZIndex]="10000">
  <app-help-menu></app-help-menu>
</p-drawer>
